import React, { useRef } from 'react';
import ScrollableContainer from 'components/shared/scrollable';
import { Modal, Button, ButtonGroup } from 'ui';

const CertificationLearnersModal = ({
  closeModal,
  isLoading,
  otherLearnersTakingCertification,
  totalUsers,
  setPage,
  page,
}) => {
  const lastLiRef = useRef();

  const containerRef = useRef();

  const handleScroll = () => {
    if (isLoading || otherLearnersTakingCertification.length === totalUsers) {
      return;
    }
    const container = containerRef.current;
    const containerBounding = container.getBoundingClientRect();
    const lastLi = lastLiRef.current;
    const lastLiBounding = lastLi.getBoundingClientRect();

    if (lastLiBounding.bottom < containerBounding.bottom) {
      setPage(page + 1);
    }
  };

  return (
    <Modal
      shown
      className="LessonVersionModal-wrapper bg-gray-lightest"
      enableFloatingDismiss
      canClickAway={false}
      onDismiss={closeModal}
    >
      <Modal.Content className="d-f fd-c">
        <h1 className="LessonVersionModal-title pb-24 ff-ss fw-n c-brand-night">
          {t(
            'certifications.learner_overview.learners_modal.recent_learner_status',
          )}
        </h1>
        <ScrollableContainer
          className="PublishedVersionCollection-scrollable bg-white pr-0"
          maxHeight={null}
          onScroll={e => {
            handleScroll(e);
          }}
          ref={containerRef}
        >
          <ul>
            <li className="CertificationLearnersModal-dataRow h-bc-gray-lightest py-16 d-f ai-c jc-sb h-56">
              <div className="CertificationLearnersModal-titleContainer d-f ai-c">
                <span className="CertificationLearnersModal-text c-brand-night ov-h to-e ws-nw fw-b">
                  {t(
                    'certifications.learner_overview.learners_modal.learner_column_title',
                  )}
                </span>
              </div>
              <div>
                <span className="CertificationLearnersModal-text c-brand-night fw-b pr-32">
                  {t(
                    'certifications.learner_overview.learners_modal.status_column_title',
                  )}
                </span>
              </div>
            </li>
            {otherLearnersTakingCertification.map(
              (
                otherLearnerTakingCertification,
                otherLearnerTakingCertificationIndex,
              ) => (
                <li
                  key={otherLearnerTakingCertification.id}
                  className="CertificationLearnersModal-dataRow h-bc-gray-lightest py-16 d-f ai-c jc-sb h-56"
                  ref={
                    otherLearnerTakingCertificationIndex ===
                    otherLearnersTakingCertification.length - 1
                      ? lastLiRef
                      : null
                  }
                >
                  <div className="BadgesModalCertificationTitleContainer d-f ai-c">
                    <span className="CertificationLearnersModal-text c-brand-night ov-h to-e ws-nw">
                      {otherLearnerTakingCertification.name}
                    </span>
                  </div>
                  <div>
                    <span className="CertificationLearnersModal-text c-brand-gray-darker">
                      {otherLearnerTakingCertification.status === 'completed'
                        ? t(
                            'certifications.learner_overview.learners_modal.status.completed',
                          )
                        : t(
                            'certifications.learner_overview.learners_modal.status.in_progress',
                          )}
                    </span>
                  </div>
                </li>
              ),
            )}
          </ul>
        </ScrollableContainer>
      </Modal.Content>
      <ButtonGroup alignEnd className="pb-16 pr-32 pt-8">
        <Button onClick={closeModal}>
          {t('certifications.learner_overview.learners_modal.close')}
        </Button>
      </ButtonGroup>
    </Modal>
  );
};

export default CertificationLearnersModal;
